import { StripeElementsAustraliaExperimentVariant } from '../../constants/statsig/types';
import { CheckoutState } from '../../state';
import { getStripeElementsAustraliaExperimentValue } from '../../utils/statsig';
import { isStripeConfirmationTokenPaymentMethodAvailable } from './isStripeConfirmationTokenPaymentMethodAvailable';

export const shouldStripeElementsBeAvailable = (state: CheckoutState) => {
    return (
        getStripeElementsAustraliaExperimentValue() ===
            StripeElementsAustraliaExperimentVariant.newExperience &&
        isStripeConfirmationTokenPaymentMethodAvailable(state)
    );
};
